import axiosInstance from '../../../api/axiosConfig';

/**
 * The GP module's API client.
 *
 * In the standalone app this was its own axios instance holding its own token in
 * localStorage. Here it is a thin prefix over reception's `axiosInstance`, so the
 * module inherits token attachment and the 401 refresh-and-retry for free, and
 * there is exactly one place in the app that knows how to authenticate.
 *
 * Every call site keeps the paths it always had (`/sales`, `/dashboard/summary`),
 * so no page or api/ module needed editing — the mount point is the only thing
 * that moved, and it lives here.
 */
const GP_PREFIX = '/api/gp';

const withPrefix = (url) => `${GP_PREFIX}${url}`;

const api = {
    get: (url, config) => axiosInstance.get(withPrefix(url), config),
    post: (url, data, config) => axiosInstance.post(withPrefix(url), data, config),
    put: (url, data, config) => axiosInstance.put(withPrefix(url), data, config),
    delete: (url, config) => axiosInstance.delete(withPrefix(url), config),
};

export default api;
